import { FooterContainer } from './styles';

const Footer = () => (
  <FooterContainer>
    <p>
      THIS TOOL PROVIDES ESTIMATES ONLY AND IS INTENDED FOR USER CONVENIENCE. NP/OC makes no representations and is not
      responsible for implications of product performance or yield promises based on tool outputs. For actual
      measurements, standardized test methods like ASTM D1622 are the appropriate means of quantifying foam density.
    </p>
    <table>
      <tbody>
        <tr>
          <td>Product</td>
          <td>Target Density (lbs/cu.ft.)*</td>
        </tr>
        <tr>
          <td>0.5lb open cell</td>
          <td>&lt;0.55</td>
        </tr>
        <tr>
          <td>NT Light</td>
          <td>&lt;0.45</td>
        </tr>
        <tr>
          <td>NT 2.0 HFO</td>
          <td>1.85-2.15</td>
        </tr>
        <tr>
          <td>NT Zero</td>
          <td>1.6-1.9</td>
        </tr>
      </tbody>
    </table>
    <p>*Approximate values, if needed run multiple samples and average for better estimations.</p>
  </FooterContainer>
);

export default Footer;
